import { Page } from '@/core/architecture'

import { MyTicketsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MyTickets Page
 * Implemented as a practical sample.
 */
export const MyTickets: Page = () => {
  const { state, actions } = useViewModel()

  return <MyTicketsTemplate state={state} {...actions} />
}
